const CircleProgressBar = ({ size, progress, strokeWidth }) => {
  const radius = (size - strokeWidth) / 2;

  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress * circumference;

  return (
    <svg className="circular-progress-bar-container" width={size} height={size}>
      <circle
        className="circular-progress-bar-background"
        stroke="#45B0F6"
        strokeWidth={strokeWidth}
        fill="none"
        cx={size / 2}
        cy={size / 2}
        r={radius}
      />

      <circle
        className="circular-progress-bar-progress"
        stroke="white"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference + ' ' + circumference}
        strokeDashoffset={strokeDashoffset}
        startOffset={0}
        strikethroughPosition={0}
        strokeLinecap="round"
        r={radius}
        fill="none"
        cx={size / 2}
        cy={size / 2}
      />
    </svg>
  );
};

export default CircleProgressBar;
